/* eslint-disable max-len */
var ICON_UI_ARROW_RIGHT = {
  v2: true,
  "default": 'M0.875 12H23.125M23.125 12L16.375 5.5M23.125 12L16.375 18.5',
  globetrotter: 'M16.5 6.375L22.125 12M22.125 12L16.5 17.625M22.125 12H1.875'
};

export { ICON_UI_ARROW_RIGHT };
//# sourceMappingURL=ICON_UI_ARROW_RIGHT.js.map
